export let EModalUrlAccountRoutes=function(EModalUrlAccountRoutes){EModalUrlAccountRoutes["OpenInApp"]="OpenInApp";return EModalUrlAccountRoutes;}({});